// Product Card Info Popup functionality
document.addEventListener('DOMContentLoaded', function() {
  const infoTriggers = document.querySelectorAll('.info-trigger');

  infoTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const popup = this.nextElementSibling;

      // Close all other popups first
      document.querySelectorAll('.info-popup').forEach(p => {
        if (p !== popup) {
          p.classList.add('hidden');
          p.classList.remove('flex');
        }
      });

      // Toggle this popup
      if (popup.classList.contains('hidden')) {
        popup.classList.remove('hidden');
        popup.classList.add('flex');
      } else {
        popup.classList.add('hidden');
        popup.classList.remove('flex');
      }
    });
  });

  // Close popup when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.info-trigger') && !e.target.closest('.info-popup')) {
      document.querySelectorAll('.info-popup').forEach(popup => {
        popup.classList.add('hidden');
        popup.classList.remove('flex');
      });
    }
  });

  // Prevent popup from closing when clicking inside it
  document.querySelectorAll('.info-popup').forEach(popup => {
    popup.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
});
